const modules = {
  user: require("./user").default,
  location: require("./location").default,
  task: require("./task").default,
};
export default modules;
